// extracted by mini-css-extract-plugin
export var active = "_ll-2";
export var recordingDot = "_ll-1";
export var recordingIndicator = "_ll-0";